export class RackZoneRequest{
    rackZoneMappingId?: number;
    constructor(rackZoneMappingId:number){
        this.rackZoneMappingId = rackZoneMappingId;
    }
}